import React from "react";
import {theme, Card, H2, Paragraph} from "@reside/ui";

import {ButtonLink} from "../../atoms/button-link";

type Props = Readonly<{
  organizationId: string;
}>;

/**
 * Displays a card that prompts the user to create an SSO configuration.
 */

export const NoCreatedSsoConfigurationFoundCard = ({
  organizationId,
}: Props): JSX.Element => {
  return (
    <Card style={{padding: theme.space[7]}}>
      <H2>SSO Configuration</H2>
      <br />
      <Paragraph fontSize={[3]}>
        No SSO configuration found. Create one to get started.
      </Paragraph>
      <br />
      <ButtonLink
        to={`/admin/organizations/${organizationId}/sso-configuration/create`}
      >
        Create SSO Configuration
      </ButtonLink>
    </Card>
  );
};
